import { OnboardingConfigModel, OnboardingConfigVerificationModel, OnboardingVerificationPluginModel } from "../../../../../../models/onboarding/onboarding.models";
import { ChildComponent } from "../../../../modules/child-component";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { autoinject, transient, useView } from "aurelia-framework";
import { computedFrom } from "aurelia-binding";
import { PropertyChangeNotifier } from "../../../../../../models/basics/basics.models";
import { ArrayUtils } from "../../../../../../utilities/arrays";
import { UserSecurityInfoModel } from "../../../../../../models/authentication/token.models";
import { UserClientService } from "../../../../../../services/authentication/user-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { Reflection } from "../../../../../../utilities/reflection";

@autoinject()
@transient()
@useView('views/pages/admin/onboarding/steps/onboarding-verification/onboarding-verification.html')
export class OnboardingVerification extends ChildComponent<OnboardingConfigModel> {

    public verificationPlugins: OnboardingVerificationPluginModel[];
    public updatePluginsSelected: PropertyChangeNotifier = new PropertyChangeNotifier();
    public currentUser: UserSecurityInfoModel;

    @computedFrom(Reflection.getPropertyPath<OnboardingVerification>(x => x.updatePluginsSelected.state))
    get pluginsSelected() {
        return this.verificationPlugins.filter(x => this.item.onboardingConfigVerifications.some(z => z.onboardingVerificationPluginId == x.onboardingVerificationPluginId));
    }

    public constructor(notificationService: NotificationClientService,
        i18N: I18N,
        private bindingSignaler: BindingSignaler,
        private userClientService: UserClientService) {
        super(notificationService, i18N);
        this.currentUser = this.userClientService.currentUser;
    }

    activate(model: { item: OnboardingConfigModel, verificationPlugins: OnboardingVerificationPluginModel[] }) {
        super.activate(model.item);
        if (!this.item.onboardingConfigVerifications) {
            this.item.onboardingConfigVerifications = [];
        }
        this.verificationPlugins = model.verificationPlugins;
    }

    getModel(onboardingVerificationPluginId: number) {
        const verification = this.item.onboardingConfigVerifications.filter(x => x.onboardingVerificationPluginId == onboardingVerificationPluginId)[0];
        const instance = verification.meta ? JSON.parse(verification.meta) : {};
        verification.metaInstance = instance;
        return { onboarding: this.item, meta: instance, verification };
    }

    getViewModel(onboardingVerificationPluginId: number) {
        const found = this.verificationPlugins.filter(x => x.onboardingVerificationPluginId == onboardingVerificationPluginId)[0];
        if (found) {
            const internalName = found.internalName;
            return `views/plugins/verification-plugins/${internalName}/${internalName}-config`;
        } else {
            return null;
        }
    }

    onSelectedPluginChanged(verification: OnboardingConfigVerificationModel) {
        if (verification.onboardingVerificationPlugin &&
            verification.onboardingVerificationPluginId != verification.onboardingVerificationPlugin.onboardingVerificationPluginId) {
            verification.meta = null;
        }
        this.updatePluginsSelected.trigger();
        this.bindingSignaler.signal('update-configuration');
    }

    removeVerification(verification: OnboardingConfigVerificationModel) {
        const index = ArrayUtils.findIndex(this.item.onboardingConfigVerifications, x => x == verification);
        if (index > -1) {
            this.item.onboardingConfigVerifications.splice(index, 1);
            this.updatePluginsSelected.trigger();
        }
    }

    addVerification() {
        const next: OnboardingConfigVerificationModel = {
            meta: '',
            onboardingConfigId: this.item.onboardingConfigId,
            onboardingConfigVerificationId: 0,
            onboardingVerificationPluginId: this.verificationPlugins.filter(x => this.item.onboardingConfigVerifications.every(z => z.onboardingVerificationPluginId != x.onboardingVerificationPluginId))[0].onboardingVerificationPluginId,
            sequenceNumber: this.item.onboardingConfigVerifications.length,
            whatsNeededIcon: 'person',
            whatsNeededTitle: '',
            whatsNeededDescription: '',
            retries: 0
        };
        this.item.onboardingConfigVerifications.push(next);
        this.updatePluginsSelected.trigger();
    }
}
